import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

import { EvaluationInterface } from 'app/assessment/evaluation/models';
import { Review, ReviewInterface } from 'app/assessment/models/review.model';
import { DynamicQuestionComponent } from 'app/assessment/questions/dynamic-question-content/dynamic-question.component';
import { UserInterface } from 'app/core/user/models';


@Component({
  selector: 'cz-comments',
  templateUrl: './comments.component.html',
  styleUrls: ['./comments.component.scss'],
})
export class CommentsComponent extends DynamicQuestionComponent implements OnInit, OnDestroy {
  @Input() public readonly entity: EvaluationInterface;
  @Input() public readonly currentUser: UserInterface;
  @Input() public readonly readOnly: boolean;
  @Input() public reviews$: BehaviorSubject<Readonly<ReviewInterface[]>>;
  @Output() public reviewAdded: EventEmitter<ReviewInterface> = new EventEmitter<ReviewInterface>();
  @Output() public reviewUpdated: EventEmitter<ReviewInterface> = new EventEmitter<ReviewInterface>();
  @Output() public reviewRemoved: EventEmitter<ReviewInterface> = new EventEmitter<ReviewInterface>();
  public editingReview: number;

  private readonly destroy$: Subject<boolean> = new Subject<boolean>();

  constructor() {
    super();
  }

  public ngOnInit(): void {}

  public ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }

  public addComment(text: string): void {
    if (!text) { return; }

    this.reviewAdded.emit(new Review({
      text,
    }));
  }

  public updateComment(text: string, reviewId: number): void {
    if (!text) { return; }

    const reviewToUpdate: ReviewInterface = Object.assign({}, this.reviews$.value.find((item: ReviewInterface) => item.id === reviewId));
    reviewToUpdate.text = text;

    this.reviewUpdated.emit(new Review(reviewToUpdate));
    this.turnEditModeOff();
  }

  public deleteComment(review: ReviewInterface): void {
    this.reviewRemoved.emit(new Review(review));
  }

  public editReview(reviewId: number): void {
    this.editingReview = reviewId;
  }

  public turnEditModeOff(): void {
    this.editingReview = null;
  }

}
